import { useState, useMemo } from 'react';

export function useValidator(fields, validator) {
  const _initialValue = { valid: true, message: '' };
  const _validator = validator;
  const _initialState = fields.reduce(
    (acc, current) => ({ ...acc, [current]: { ..._initialValue } }),
    {},
  );

  const checkAll = (values) => Object.values(values).every((value) => value.valid);

  const validate = (validable) => {
    const isSingleValidable = validables.hasOwnProperty(validable);
    if (validable && !isSingleValidable) {
      console.error('Validator validate passed a nonexisting validable' + validable);
    }

    const message = _validator();
    if (isSingleValidable) {
      const newSingleValidables = {
        ...validables,
        [validable]: message.hasOwnProperty(validable)
          ? { valid: false, message: message[validable] }
          : { ..._initialValue },
      };
      setValidables(newSingleValidables);
      return newSingleValidables[validable].valid;
    }

    const newValidables = Object.entries(validables).reduce(
      (acc, [key, _]) => ({
        ...acc,
        [key]: message.hasOwnProperty(key)
          ? { valid: false, message: message[key] }
          : { ..._initialValue },
      }),
      {},
    );
    setValidables(newValidables);
    return checkAll(newValidables);
  };

  const reset = (validable) => {
    const isSingleValidable = validables.hasOwnProperty(validable);
    if (validable && !isSingleValidable) {
      console.error('Validator reset passed a nonexisting validable' + validable);
    }

    if (isSingleValidable) {
      const newValidables = {
        ...validables,
        [validable]: _initialValue,
      };
      setValidables(newValidables);
    } else {
      setValidables(_initialState);
    }
  };

  const [validables, setValidables] = useState(_initialState);
  const isAllValid = useMemo(() => checkAll(validables), [validables]);

  return [validables, { validate, isAllValid, reset }];
}
